import {
  always,
  complement,
  defaultTo,
  filter,
  ifElse,
  isNil,
  map,
  max,
  path,
  pipe,
  prop,
  propEq,
  reduce,
  values,
  either,
  equals,
  compose,
  both,
  anyPass,
  T,
  cond,
  gt,
} from 'ramda';

import messages from './messages';

export const getMaxTicketValue = ifElse(
  complement(isNil),
  pipe(
    filter(propEq('enabled', true)),
    map(({ price }) => parseFloat(price)),
    values,
    reduce(max, 0)
  ),
  always(null)
);

export const getPrice = ifElse(
  prop('isGroup'),
  prop('groupPrice'),
  pipe(
    prop('types'),
    getMaxTicketValue,
    defaultTo('-')
  )
);

const isPropNilOrZero = propName =>
  compose(
    either(isNil, equals(0)),
    prop(propName)
  );

const isNotGroup = complement(path(['tickets', 'isGroup']));
const isMaxGroupSizeNotDefined = isPropNilOrZero('maxGroupSize');
const isMinGroupSizeNotDefined = isPropNilOrZero('minGroupSize');
const isGroupSizeNotDefined = both(isMaxGroupSizeNotDefined, isMinGroupSizeNotDefined);
const isGroupAndMaxGroupSizeEquals1 = both(path(['tickets', 'isGroup']), propEq('maxGroupSize', 1));
const isMinGroupSize1WithoutMaxGroupSize = both(propEq('minGroupSize', 1), isPropNilOrZero('maxGroupSize'));

const isGroupAndMinGroupSizeEquals1WithoutMaxGroupSize = both(
  path(['tickets', 'isGroup']),
  isMinGroupSize1WithoutMaxGroupSize
);

const isGroupWithoutSizes = both(path(['tickets', 'isGroup']), isGroupSizeNotDefined);

export const getGroupSizeMessageProps = cond([
  [either(isGroupSizeNotDefined, isMinGroupSize1WithoutMaxGroupSize), always(undefined)],
  [isMaxGroupSizeNotDefined, ({ minGroupSize: count }) => ({ ...messages.from, values: { count } })],
  [isMinGroupSizeNotDefined, ({ maxGroupSize: count }) => ({ ...messages.to, values: { count } })],
  [
    ({ minGroupSize, maxGroupSize }) => equals(minGroupSize, maxGroupSize),
    ({ maxGroupSize: count }) => ({ ...messages.same, values: { count } }),
  ],
  [
    ({ minGroupSize, maxGroupSize }) => gt(maxGroupSize, minGroupSize),
    ({ minGroupSize, maxGroupSize }) => ({ ...messages.fromTo, values: { from: minGroupSize, to: maxGroupSize } }),
  ],
]);

export const getPeopleMessageProps = cond([
  [
    anyPass([isNotGroup, isGroupAndMinGroupSizeEquals1WithoutMaxGroupSize, isGroupAndMaxGroupSizeEquals1]),
    always({ ...messages.perGuest }),
  ],
  [isGroupWithoutSizes, always({ ...messages.perGroup })],
  [
    T,
    ({ minGroupSize, maxGroupSize }) => ({
      ...messages.forGuests,
      values: { count: maxGroupSize || minGroupSize },
    }),
  ],
]);
